import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/services/login.service';
import { Firmas } from '../models/firmas';
import { IGestionarFirmasService } from './ports/i-gestionar-firmas-service';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { ResumenEstados } from '../models/resumen-inicial';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';

@Injectable({
  providedIn: 'root'
})
export class GestionaFirmasApiService implements IGestionarFirmasService{

  firmas: Firmas[]; // = [];
  resumenHome: any;

  private readonly URL_GET_FIRMAS: string = `${environment.ApiUrlV3}api/Firmas/GetFirmas`;
  private readonly URL_GET_RESUMEN_ESTADOS: string = `${environment.ApiUrlV3}api/Firmas/GetResumenEstados/true`;
  private readonly URL_GET_DESPLEGABLES_FIRMAS: string = `${environment.ApiUrlV3}api/Firmas/GetDesplegables`;
  private readonly URL_GET_RESUMEN_ESTADOS_INICIAL: string = `${environment.ApiUrlV3}api/Firmas/GetResumenEstadosInicial`;

  constructor(private client: HttpClient,
              private endpointSerivce:EndpointService,
              private loginService: LoginService,
              private conversionDatosApiService: ConversionDatosApiService) { }

  GetFirmas(filtrosFirmas: FiltroSqp[], pageNumber:number, pageSize:number = 100, orden: OrdenColumna = {campoOrden:'', orden:''}, refresh?: boolean): Observable<void | any[]> {
    let url = this.endpointSerivce.UrlGetFirmas.replace('{todos}', 'true');

    let filtrosEmpresa = filtrosFirmas.find(x=>x.titulo=='Empresa')?.valoresSeleccionados?.listaValores?.join(',');
    let filtrosCentro = filtrosFirmas.find(x=>x.titulo=='Centro')?.valoresSeleccionados?.listaValores?.join(',');
    let filtrosTipoDosier = filtrosFirmas.find(x=>x.titulo=='Tipo dosier')?.valoresSeleccionados?.listaValores?.join(',');
    let filtroFromEnvio = filtrosFirmas.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaDesde?.toISOString()?? '';
    let filtroToEnvio = filtrosFirmas.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaHasta?.toISOString() ?? '';
    let filtroFromContrato = filtrosFirmas.find(x=>x.titulo=='Fecha contrato')?.valoresSeleccionados?.valorFechaDesde?.toISOString()?? '';
    let filtroToContrato = filtrosFirmas.find(x=>x.titulo=='Fecha de contrato')?.valoresSeleccionados?.valorFechaHasta?.toISOString() ?? '';
    let filtroEstado = this.conversionDatosApiService.conversionEstadoSalida(filtrosFirmas.find(x=>x.titulo=='Estado')?.valoresSeleccionados?.valorString);
    let filtroNuevo = filtrosFirmas.find(x=>x.titulo=='Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosFirmas.find(x=>x.titulo=='Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar= filtrosFirmas.find(x=>x.titulo=='Buscar')?.valoresSeleccionados?.valorString;
    // console.log('filtroEstado: ', filtroEstado)
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
      .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
      .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
      .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
      .set('filtros[CODIGOEMPRESA]', filtrosEmpresa ? filtrosEmpresa : '')
      .set('filtros[CODIGOCENTRO]', filtrosCentro ? filtrosCentro : '')
      .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
      .set('filtros[EstadoString]', filtroEstado ? filtroEstado : '')
      .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
      .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
      .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }

    //si fechaFirma y orden desc, se elimina el orden ya que ya lo hace el back por defecto
    if(orden.campoOrden == 'fechaFirma' && orden.orden =='desc') orden = {campoOrden: '', orden: ''};

    if (orden.campoOrden) {
      httpOptions.params = httpOptions.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
    }

    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{
        return this.firmas = response.Data;
        })
      )

  }

  GetInfoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetDocumentos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;
    //CARGAMOS LOS DOCUMETNOS
    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{
      return  JSON.parse(response.Data)
    }))

  }

  GetInfoEventos(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetEventos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;

    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{
      return JSON.parse( response.Data);
    }))
  }

  GetInfoTipoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetTiposDocumentos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;

    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{
      return JSON.parse( response.Data);
    }))
  }

  BorrarFirmas(ids: number[]): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      }),
      body: ids,
    };
    return this.client.delete(this.endpointSerivce.UrlEliminaFirmas, options).pipe(
      map((response: any) =>{
        if (response.Ok) return JSON.parse(response.Data);
        else throw new Error(response);
      })
    );
  }

  BorrarFirma(idFirma: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.delete(this.endpointSerivce.UrlFirmaElimina.replace('{idFirma}', idFirma.toString()), options).pipe(
      map((response: any) =>{
        if (response.Ok) return "Firma eliminada correctamente";
        else throw new Error(response);
      })
    );
  }

  CancelarFirma(idFirma: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post(this.endpointSerivce.UrlFirmaCancela.replace('{idFirma}', idFirma.toString()), null, options).pipe(
      map((response: any) =>{
        if (response.Ok) return "Firma cancelada correctamente";
        else throw new Error(`No se ha podido cancelar la firma por un error interno de Signaturit: ${response.Message}`);
      })
    );
  }

  DescargaFirmaCompleta(id: any): Observable<string> {


    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };    return this.client.get(this.endpointSerivce.UrlDescargarFirmas.replace('{id}', id.toString()),options).pipe(
      map((response: any) => {
        if(response == null) throw new Error("No se han encontrado ficheros disponibles para descargar");
        // Recuperamos el fichero en formato base64 string y obtenemos el array de bytes
        return atob(response.Data);
      }))
  }

  cargarResumenHome(filtrosSqp: FiltroSqp[]): Observable<any>{
    let filtroFromEnvio = filtrosSqp.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaDesde?.toISOString()?? '';
    let filtroToEnvio = filtrosSqp.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaHasta?.toISOString() ?? '';

    let httpOptions: any ={
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
      params: new HttpParams()
      .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
      .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
    };
    return this.client.get(this.URL_GET_RESUMEN_ESTADOS_INICIAL, httpOptions).pipe(
      map((response: any)=>{
        return this.resumenHome = response;
        })
      )
  }

  getResumenEstados(filtrosSqp: FiltroSqp[]): Observable<ResumenEstados[]> {

    let filtrosEmpresa = filtrosSqp.find(x=>x.titulo=='Empresa')?.valoresSeleccionados?.listaValores?.join(',');
    let filtrosCentro = filtrosSqp.find(x=>x.titulo=='Centro')?.valoresSeleccionados?.listaValores?.join(',');
    let filtrosTipoDosier = filtrosSqp.find(x=>x.titulo=='Tipo dosier')?.valoresSeleccionados?.listaValores?.join(',');
    let filtroFromEnvio = filtrosSqp.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaDesde?.toISOString()?? '';
    let filtroToEnvio = filtrosSqp.find(x=>x.titulo=='Fecha de envío')?.valoresSeleccionados?.valorFechaHasta?.toISOString() ?? '';
    let filtroFromContrato = filtrosSqp.find(x=>x.titulo=='Fecha contrato')?.valoresSeleccionados?.valorFechaDesde?.toISOString()?? '';
    let filtroToContrato = filtrosSqp.find(x=>x.titulo=='Fecha contrato')?.valoresSeleccionados?.valorFechaHasta?.toISOString() ?? '';
    let filtroNuevo = filtrosSqp.find(x=>x.titulo=='Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosSqp.find(x=>x.titulo=='Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar = filtrosSqp.find(x=>x.titulo=='Buscar')?.valoresSeleccionados?.valorString;

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
      .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
      .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
      .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
      .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
      .set('filtros[CODIGOEMPRESA]', filtrosEmpresa ? filtrosEmpresa : '')
      .set('filtros[CODIGOCENTRO]', filtrosCentro ? filtrosCentro : '')
      .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
      .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
      .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
      .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }
    return this.client.get(this.URL_GET_RESUMEN_ESTADOS, httpOptions).pipe(
      map((response: any)=>{
        return response;
      })
    );
  }

  getDesplegablesFiltros(): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      })
    };
    return this.client.get(`${this.URL_GET_DESPLEGABLES_FIRMAS}`, httpOptions).pipe(
      map((response: any)=>{
        return response
      })
    );
  }


}
